import { nextTick, onBeforeUnmount, watch } from "vue";

// Keep chronological chat threads at the bottom on load/new messages, including
// delayed rich-text layout. Reading older messages or expanding one stays manual.
export function useChatScroll(thread, revision) {
  let following = true;
  let observer;
  let disposed = false;
  let attached;
  const align = () => {
    if (!disposed && following && thread.value) {
      thread.value.scrollTop = thread.value.scrollHeight;
    }
  };
  const onScroll = () => {
    const element = thread.value;
    if (element) following = element.scrollHeight - element.clientHeight - element.scrollTop <= 4;
  };
  const onInteraction = event => {
    if (event.target.closest?.("button, a")) following = false;
  };
  const detach = () => {
    attached?.removeEventListener("scroll", onScroll);
    attached?.removeEventListener("pointerdown", onInteraction);
    attached?.removeEventListener("keydown", onInteraction);
    observer?.disconnect();
    attached = null;
  };
  const observe = () => {
    observer?.disconnect();
    if (!thread.value || typeof ResizeObserver === "undefined") return;
    observer ||= new ResizeObserver(align);
    observer.observe(thread.value);
    for (const message of thread.value.children) observer.observe(message);
  };
  watch(thread, element => {
    detach();
    attached = element;
    following = true;
    element?.addEventListener("scroll", onScroll, { passive: true });
    element?.addEventListener("pointerdown", onInteraction);
    element?.addEventListener("keydown", onInteraction);
    observe();
    align();
  }, { flush: "post" });
  watch(revision, async () => {
    following = true;
    await nextTick();
    if (disposed) return;
    observe();
    align();
  }, { flush: "post" });
  onBeforeUnmount(() => {
    disposed = true;
    detach();
  });
}
